import { startCase } from 'lodash-es';

export function makeSelectOptions(arr) {
  return arr.map((value) => ({
    value,
    label: startCase(value.toLowerCase()),
  }));
}
